export const bytesToSize = (bytes: number) => {
  const sizes = ['Octet', 'Ko', 'Mo', 'Go', 'To'];
  if (bytes <= 0) return '0 Octet';
  const size_id = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, size_id)) + ' ' + sizes[size_id];
};
